import { Edges, OrbitControls, PerspectiveCamera } from "@react-three/drei";
import { Canvas, useFrame, useLoader } from "@react-three/fiber";
import { ReactNode, Suspense, useRef } from "react";
import { Mesh } from "three";
import { STLLoader, WebGL } from "three/examples/jsm/Addons.js";

function Loader() {
	return <>...</>;
}

function Stl({ url }: { url: string }) {
	const stl = useLoader(STLLoader, url);
	const ref = useRef<Mesh>(null!);
	useFrame(({ clock }) => {
		if (ref.current) {
			ref.current.rotation.y = clock.getElapsedTime() / 8;
			ref.current.geometry.center();
		}
	});
	return (
		<>
			<mesh ref={ref} scale={1.2} castShadow receiveShadow>
				<primitive attach="geometry" object={stl}></primitive>
				<meshStandardMaterial transparent />
				<Edges visible={false} scale={1} renderOrder={1000}>
					<meshBasicMaterial transparent color="#ffffff" />
				</Edges>
			</mesh>
		</>
	);
}

type StlLoaderProps = {
	alternative: ReactNode;
};

function StlLoader({ alternative }: StlLoaderProps) {
	if (!WebGL.isWebGL2Available()) {
		return alternative;
	}
	return (
		<>
			<Canvas
				style={{ backgroundColor: "#1444E1", height: "100vh", width: "50vw" }}
			>
				<Suspense fallback={<Loader />}>
					<PerspectiveCamera
						makeDefault
						fov={45}
						aspect={window.innerWidth / window.innerHeight}
						position-z={70}
					></PerspectiveCamera>
					<Stl url={"/example.stl"}></Stl>
					<directionalLight color={0xffffff} position={[1, 0.75, 0.5]} />
					<directionalLight color={0xffffff} position={[-1, 0.75, -0.5]} />
					<directionalLight color={0xffffff} position={[-1, -0.75, -0.5]} />
					<directionalLight color={0xffffff} position={[-1, 0.75, 0.5]} />
					<directionalLight color={0xffffff} position={[1, -0.75, -0.5]} />
					<directionalLight color={0xffffff} position={[1, -0.75, 0.5]} />
				</Suspense>
				<OrbitControls />
			</Canvas>
		</>
	);
}

export default StlLoader;
